import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import Sidebar from "../../components/Sidebar";
import BottomNav from "../../components/BottomNav";
import { FaWallet, FaPlus, FaExchangeAlt, FaMoneyCheckAlt } from "react-icons/fa";

import FundWalletForm from "../../components/wallet/FundWalletForm";
import LoanRequestForm from "../../components/wallet/LoanRequestForm";
import MoneyTransferForm from "../../components/wallet/MoneyTransferForm";
import WithdrawWalletForm from "../../components/wallet/WithdrawWalletForm";
import WalletOverview from "../../components/wallet/WalletOverviewForm";

export default function WalletPage() {
  const [activeAction, setActiveAction] = useState("");
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const action = params.get("action");

    if (action === "fund") setActiveAction("fund");
    if (action === "transfer") setActiveAction("transfer");
    if (action === "withdraw") setActiveAction("withdraw");
    if (action === "loan") setActiveAction("loan");
  }, [location.search]);

  const handleSuccess = () => setActiveAction("");

  const renderActionComponent = () => {
    switch (activeAction) {
      case "transfer":
        return <MoneyTransferForm onSuccess={handleSuccess} />;
      case "fund":
        return <FundWalletForm onSuccess={handleSuccess} />;
      case "loan":
        return <LoanRequestForm onSuccess={handleSuccess} />;
      case "withdraw":
        return <WithdrawWalletForm onSuccess={handleSuccess} />;
      default:
        return (
          <div className="space-y-6">
            <section className="rounded-2xl border border-black/5 dark:border-white/10 bg-white dark:bg-slate-900 shadow-sm p-5">
              <h2 className="text-base font-semibold text-slate-900 dark:text-white">
                Actions rapides
              </h2>
              <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
                Choisissez une action à effectuer
              </p>

              <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4">
                <ActionTile
                  icon={<FaPlus />}
                  iconWrap="bg-emerald-500/10 text-emerald-600 dark:text-emerald-400"
                  label="Ajouter des fonds"
                  description="Rechargez votre portefeuille en quelques secondes."
                  onClick={() => setActiveAction("fund")}
                />
                <ActionTile
                  icon={<FaExchangeAlt />}
                  iconWrap="bg-blue-500/10 text-blue-600 dark:text-blue-400"
                  label="Envoyer à un utilisateur"
                  description="Transférez de l’argent à vos contacts."
                  onClick={() => setActiveAction("transfer")}
                />
                <ActionTile
                  icon={<FaMoneyCheckAlt />}
                  iconWrap="bg-purple-500/10 text-purple-600 dark:text-purple-400"
                  label="Retirer des fonds"
                  description="Effectuez un retrait sécurisé."
                  onClick={() => setActiveAction("withdraw")}
                />
                <ActionTile
                  icon={<FaWallet />}
                  iconWrap="bg-amber-500/10 text-amber-700 dark:text-amber-400"
                  label="Demander un prêt"
                  description="Envoyez une demande en quelques clics."
                  onClick={() => setActiveAction("loan")}
                />
              </div>
            </section>

            <WalletOverview />
          </div>
        );
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-950">
      <div className="flex">
        <Sidebar />

        <main className="flex-1 pb-28 md:pb-8">
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-6 space-y-6">
            <div className="flex items-end justify-between gap-4">
              <div>
                <h1 className="text-xl sm:text-2xl font-semibold tracking-tight text-slate-900 dark:text-white">
                  Mon portefeuille
                </h1>
                <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
                  Gérez vos fonds facilement
                </p>
              </div>

              {activeAction && (
                <button
                  onClick={() => setActiveAction("")}
                  className="rounded-2xl border border-black/10 dark:border-white/10 bg-white dark:bg-slate-900 px-4 py-2 text-sm font-medium
                             text-slate-900 dark:text-white hover:bg-black/5 dark:hover:bg-white/10 transition"
                >
                  ← Retour
                </button>
              )}
            </div>

            {renderActionComponent()}
          </div>

          <div className="md:hidden">
            <BottomNav />
          </div>
        </main>
      </div>
    </div>
  );
}

function ActionTile({ icon, iconWrap, label, description, onClick }) {
  return (
    <button
      onClick={onClick}
      className="text-left rounded-2xl border border-black/5 dark:border-white/10 bg-white dark:bg-slate-950
                 shadow-sm hover:shadow-md transition p-4"
    >
      <div className="flex items-start gap-4">
        <div className={`h-12 w-12 rounded-2xl flex items-center justify-center ${iconWrap}`}>
          <span className="text-xl">{icon}</span>
        </div>
        <div className="min-w-0">
          <div className="font-semibold text-slate-900 dark:text-white">{label}</div>
          <div className="mt-1 text-sm text-slate-500 dark:text-slate-400">{description}</div>
        </div>
      </div>

      <div className="mt-4 flex items-center justify-between">
        <span className="text-sm font-medium text-blue-600 dark:text-blue-400">Ouvrir</span>
        <span className="text-slate-400 dark:text-slate-300">→</span>
      </div>
    </button>
  );
}